<template>
  <div class="finance-logs">
    <van-nav-bar title="资金流水" left-arrow @click-left="$router.back()" fixed placeholder />

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        class="log-list"
      >
        <div v-for="item in list" :key="item.id" class="log-item">
          <div class="log-header">
            <span class="log-title">{{ formatType(item.type) }}</span>
            <span :class="['log-amount', getAmountClass(item.type)]">
              {{ getAmountPrefix(item.type) }}{{ item.amount }}
            </span>
          </div>
          <div class="log-body">
            <div class="log-row">
              <span class="label">变动后可用：</span>
              <span class="value">¥{{ item.balance_after }}</span>
            </div>
            <div class="log-row">
              <span class="label">变动后冻结：</span>
              <span class="value">¥{{ item.frozen_balance_after }}</span>
            </div>
            <div class="log-row" v-if="item.related_id">
              <span class="label">关联单号：</span>
              <span class="value">{{ item.related_id }}</span>
            </div>
            <div class="log-row" v-if="item.remark">
              <span class="label">备注：</span>
              <span class="value">{{ item.remark }}</span>
            </div>
          </div>
          <div class="log-footer">
            <span class="log-time">{{ item.created_at }}</span>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  name: 'FinanceLogs',
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pageSize: 15
    }
  },
  methods: {
    async onLoad() {
      try {
        const res = await this.$common.cusHttp(
          this,
          `/api/saas_finance.php?action=logs&page=${this.page}&pageSize=${this.pageSize}`,
          {},
          'get'
        )
        const data = JSON.parse(res.data)
        
        if (this.refreshing) {
          this.list = []
          this.refreshing = false
        }

        if (data.status && data.data && data.data.list) {
          const items = data.data.list
          this.list.push(...items)
          this.page++

          if (items.length < this.pageSize) {
            this.finished = true
          }
        } else {
          this.finished = true
        }
      } catch (err) {
        console.error('加载资金流水失败:', err)
        this.finished = true
      } finally {
        this.loading = false
      }
    },
    onRefresh() {
      this.finished = false
      this.loading = true
      this.page = 1
      this.onLoad()
    },
    formatType(type) {
      const map = {
        1: '佣金收入(冻结)',
        2: '佣金解冻(入账)',
        3: '提现扣除',
        4: '提现驳回(退回)',
        5: '订单取消(退款扣除)'
      }
      return map[type] || '未知类型'
    },
    getAmountPrefix(type) {
      // 2(解冻入账), 4(驳回退回) 是增加可用余额
      // 1(冻结收入) 是增加冻结余额
      if ([1, 2, 4].includes(Number(type))) {
        return '+'
      }
      return '-'
    },
    getAmountClass(type) {
      if ([1, 2, 4].includes(Number(type))) {
        return 'text-green'
      }
      return 'text-red'
    }
  }
}
</script>

<style scoped>
.finance-logs {
  min-height: 100vh;
  background-color: #f7f8fa;
}

.log-list {
  padding: 12px;
}

.log-item {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
}

.log-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f5f5f5;
}

.log-title {
  font-size: 15px;
  font-weight: bold;
  color: #323233;
}

.log-amount {
  font-size: 18px;
  font-weight: bold;
}

.text-green {
  color: #07c160;
}

.text-red {
  color: #ee0a24;
}

.log-body {
  font-size: 13px;
  color: #666;
}

.log-row {
  display: flex;
  margin-bottom: 6px;
  line-height: 1.4;
}

.log-row .label {
  color: #999;
  width: 85px;
  flex-shrink: 0;
}

.log-row .value {
  flex: 1;
  word-break: break-all;
}

.log-footer {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
  text-align: right;
}
</style>
